/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import cx from 'classnames';
import { useTheme, SvgUpload } from '../utils/index.js';
import { Anchor } from '../Typography/Anchor/Anchor.js';
/**
 * Default template to be used with the `FileUpload` wrapper component.
 * Contains a hidden input with styled labels (customizable).
 * @example
 * <FileUploadTemplate onChange={(e) => console.log(e.target.files)} />
 */
export const FileUploadTemplate = (props) => {
    const { onChange, acceptMultiple = true, acceptType, label = 'Choose a file', subtitle = 'or drag & drop it here.', children, className, ...rest } = props;
    useTheme();
    return (React.createElement("div", { className: cx('iui-file-upload-template', className), ...rest },
        React.createElement(SvgUpload, { className: 'iui-template-icon', "aria-hidden": true }),
        React.createElement("div", { className: 'iui-template-text' },
            React.createElement(Anchor, { as: 'label' },
                React.createElement("input", { className: 'iui-browse-input', type: 'file', onChange: onChange, multiple: acceptMultiple, accept: acceptType }),
                label),
            React.createElement("div", null, subtitle),
            children)));
};
export default FileUploadTemplate;
